import Authenticated from "./components/Authenticated";
export default function Chat() {
  return (
    <div>
      <Authenticated />
    </div>
  );
}
